<template>
  <div class="not-found">
    <h1>404</h1>
    <p>Page not found</p>
  </div>
</template>

<script>
export default {
  created() {
    document.title = "Not found"
  }
}
</script>

<style scoped>
  .not-found {
    text-align: center;
    padding: 80px 0;
  }
  .not-found h1 {
    font-family: "Inter", sans-serif;
    font-size: 72px;
    font-weight: 700;
    color: var(--text-secondary);
    margin-bottom: 8px;
  }
  .not-found p {
    color: var(--text-secondary);
    font-size: 16px;
  }
</style>